import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
import { WhatsAppIcon } from './WhatsAppIcon';
export function QuoteForm() {
  const {
    language
  } = useLanguage();
  const [formData, setFormData] = useState({
    pickup: '',
    destination: '',
    date: '',
    time: '',
    passengers: ''
  });
  const content = {
    en: {
      formTitle: 'Get your exact transfer price',
      formSubtitle: 'Send your trip details and receive your quote on WhatsApp in minutes.',
      labels: {
        pickup: 'PICKUP LOCATION',
        destination: 'DESTINATION',
        date: 'DATE',
        time: 'TIME',
        passengers: 'NUMBER OF PASSENGERS'
      },
      placeholders: {
        pickup: 'e.g. Ibiza Airport',
        destination: 'e.g. Nobu Hotel',
        passengers: '2'
      },
      formCta: 'Get price on WhatsApp',
      formFooter: 'No payment required · Instant reply · Fixed price'
    },
    es: {
      formTitle: 'Obtén tu precio exacto de traslado',
      formSubtitle: 'Envía los detalles de tu viaje y recibe tu presupuesto por WhatsApp en minutos.',
      labels: {
        pickup: 'LUGAR DE RECOGIDA',
        destination: 'DESTINO',
        date: 'FECHA',
        time: 'HORA',
        passengers: 'NÚMERO DE PASAJEROS'
      },
      placeholders: {
        pickup: 'ej. Aeropuerto de Ibiza',
        destination: 'ej. Hotel Nobu',
        passengers: '2'
      },
      formCta: 'Pedir precio por WhatsApp',
      formFooter: 'Sin pago requerido · Respuesta instantánea · Precio fijo'
    }
  };
  const text = content[language];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = language === 'en' ? `Hello, I need a transfer in Ibiza.%0APickup: ${formData.pickup}%0ADestination: ${formData.destination}%0ADate: ${formData.date}%0ATime: ${formData.time}%0APassengers: ${formData.passengers}` : `Hola, necesito un transfer en Ibiza.%0ARecogida: ${formData.pickup}%0ADestino: ${formData.destination}%0AFecha: ${formData.date}%0AHora: ${formData.time}%0APasajeros: ${formData.passengers}`;
    window.open(`https://wa.me/34613756211?text=${message}`, '_blank');
  };
  return <section className="py-14 md:py-20 bg-warm-cream/30" data-id="element-248">
      <div className="mx-auto max-w-7xl px-5" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-250">
          <div className="max-w-xl mx-auto" data-id="element-251">
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border border-stone/10" data-id="element-252">
              <h2 className="text-2xl md:text-3xl font-heading text-navy text-center mb-3" data-id="element-253">
                {text.formTitle}
              </h2>
              <p className="text-slate text-center mb-8" data-id="element-254">{text.formSubtitle}</p>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-255">
                <div data-id="element-256">
                  <label className="block text-xs font-medium tracking-wider text-slate uppercase mb-2" data-id="element-257">
                    {text.labels.pickup}
                  </label>
                  <input type="text" value={formData.pickup} onChange={e => setFormData({
                  ...formData,
                  pickup: e.target.value
                })} placeholder={text.placeholders.pickup} className="w-full px-4 py-3 bg-warm-white border border-stone/10 rounded-lg text-navy placeholder:text-stone focus:outline-none focus:ring-2 focus:ring-gold-subtle/20 focus:border-gold-subtle/30 transition-all" required data-id="element-258" />
                </div>

                <div data-id="element-259">
                  <label className="block text-xs font-medium tracking-wider text-slate uppercase mb-2" data-id="element-260">
                    {text.labels.destination}
                  </label>
                  <input type="text" value={formData.destination} onChange={e => setFormData({
                  ...formData,
                  destination: e.target.value
                })} placeholder={text.placeholders.destination} className="w-full px-4 py-3 bg-warm-white border border-stone/10 rounded-lg text-navy placeholder:text-stone focus:outline-none focus:ring-2 focus:ring-gold-subtle/20 focus:border-gold-subtle/30 transition-all" required data-id="element-261" />
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-262">
                  <div data-id="element-263">
                    <label className="block text-xs font-medium tracking-wider text-slate uppercase mb-2" data-id="element-264">
                      {text.labels.date}
                    </label>
                    <input type="date" value={formData.date} onChange={e => setFormData({
                    ...formData,
                    date: e.target.value
                  })} className="w-full px-4 py-3 bg-warm-white border border-stone/10 rounded-lg text-navy focus:outline-none focus:ring-2 focus:ring-gold-subtle/20 focus:border-gold-subtle/30 transition-all" required data-id="element-265" />
                  </div>
                  <div data-id="element-266">
                    <label className="block text-xs font-medium tracking-wider text-slate uppercase mb-2" data-id="element-267">
                      {text.labels.time}
                    </label>
                    <input type="time" value={formData.time} onChange={e => setFormData({
                    ...formData,
                    time: e.target.value
                  })} className="w-full px-4 py-3 bg-warm-white border border-stone/10 rounded-lg text-navy focus:outline-none focus:ring-2 focus:ring-gold-subtle/20 focus:border-gold-subtle/30 transition-all" required data-id="element-268" />
                  </div>
                </div>

                <div data-id="element-269">
                  <label className="block text-xs font-medium tracking-wider text-slate uppercase mb-2" data-id="element-270">
                    {text.labels.passengers}
                  </label>
                  <input type="number" min="1" max="16" value={formData.passengers} onChange={e => setFormData({
                  ...formData,
                  passengers: e.target.value
                })} placeholder={text.placeholders.passengers} className="w-full px-4 py-3 bg-warm-white border border-stone/10 rounded-lg text-navy placeholder:text-stone focus:outline-none focus:ring-2 focus:ring-gold-subtle/20 focus:border-gold-subtle/30 transition-all" required data-id="element-271" />
                </div>

                <button type="submit" className="w-full bg-whatsapp hover:bg-whatsapp-hover text-white py-4 rounded-full font-medium flex items-center justify-center space-x-2 transition-all shadow-lg shadow-whatsapp/20 hover:shadow-whatsapp/30" data-id="element-272">
                  <WhatsAppIcon className="w-5 h-5" data-id="element-273" />
                  <span data-id="element-274">{text.formCta}</span>
                </button>

                <p className="text-center text-xs text-stone" data-id="element-275">
                  {text.formFooter}
                </p>
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}